import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Careerpagebanner from '../components/Careerpagebanner';
import Footer from '../components/Footer';

export default function Viewoppingcareer() {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    yearofexp: '',
  });

  const [resumeFile, setResumeFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!job) {
    return (
      <div className="container mt-4 mb-2">
        <h4>No job data found.</h4>
        <button onClick={() => navigate(-1)} className="btn btn-secondary mt-3">Go Back</button>
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });
    if (resumeFile) {
      formPayload.append('uploadresume', resumeFile);
    }

    try {
      const res = await fetch('http://jbytam.com/career_Mailer.php', {
        method: 'POST',
        body: formPayload,
      });

      const result = await res.json();

      if (result.status === 'success') {
        alert('Message sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          position: '',
          yearofexp: '',
        });
        setResumeFile(null);
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Header />
      <Careerpagebanner />
      <div className='contact-inner-area'>
        <div className="container mt-5">
          <div className="row">
            <div className='col-lg-7'>
              <h2>{job.title}</h2>
              <h5 className="text-muted">{job.subtitle}</h5>
              <p><strong>Salary:</strong> {job.salary}</p>
              {job.qualification && <p><strong>Qualification:</strong> {job.qualification}</p>}
              {job.experience && <p><strong>Experience:</strong> {job.experience}</p>}
              <p><strong>Gender:</strong> {job.gender}</p>
              <p><strong>Work:</strong> {job.work}</p>
              <p><strong>Location:</strong> {job.location}</p>
              <hr />
              {job.eligibility && (
                <>
                  <h5>Eligibility:</h5>
                  <ul>
                    {job.eligibility.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              {job.responsibilities && (
                <>
                  <h5>Key Responsibilities:</h5>
                  <ul>
                    {job.responsibilities.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              <button onClick={() => navigate(-1)} className="btn btn-primary mt-4 mb-5">Back to Jobs</button>
            </div>

            <div className='col-lg-5'>
              <form className="contact-main-boxarea contact-opaningcareer" onSubmit={handleSubmit}>
                <h3>Apply Now</h3>
                <p className='mt-2'>We’ll get back to you at the earliest during business hours.</p>

                <div className="input-area">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="text"
                    name="position"
                    placeholder="Position Applying For"
                    value={formData.position}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="text"
                    name="yearofexp"
                    placeholder="Years of Experience"
                    value={formData.yearofexp}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-area">
                  <input
                    type="file"
                    name="uploadresume"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                    required
                  />
                </div>

                <div className="text-end mt-3">
                  <button type="submit" className="vl-btn1" disabled={isSubmitting}>
                    {isSubmitting ? 'Sending...' : 'Send Now'} <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
